import { ThemeOptions } from '@mui/material/styles/createTheme';

export const typography: ThemeOptions['typography'] = {
  fontFamily: [
    '"Open Sans"',
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(','),
  h1: {
    fontSize: '2.5rem',
    lineHeight: '3.25rem',
    fontWeight: 'bold',
  },
  h2: {
    fontSize: '2rem',
    lineHeight: '2.75rem',
    fontWeight: 'bold',
  },
  h3: {
    fontSize: '1.5rem',
    lineHeight: '2.25rem',
    fontWeight: 'bold',
  },
  h4: {
    fontSize: '1.25rem',
    lineHeight: '1.75rem',
    fontWeight: 'bold',
  },
  h5: {
    fontSize: '1rem',
    lineHeight: '1.25rem',
    fontWeight: 'bold',
  },
};
